import PropTypes from 'prop-types';
import React, {
	Component,
} from 'react';

import GraphQL from '~/types/graphql';

import AttachedEnterpriseRibbon from '~/components/patterns/pricingPlans/AttachedEnterpriseRibbon';
import List, {
	ListSize,
} from '~/components/patterns/lists/List';
import PlanCard from '~/components/patterns/pricingPlans/PlanCard';
import PlanName from '~/components/names/PlanName';
import PlanPriceSummary, {
	PlanPriceSummaryView,
} from './PlanPriceSummary';

import {
	LIST_OF_ALL_PLANS,
} from '~/model/universal';



class PlansOverviewSection extends Component {

	constructor(props, context) {
		super(props, context);

		this._handlePlanClick = this._handlePlanClick.bind(this);
	}



	_handlePlanClick(type, e) {
		e.preventDefault();

		const {
			onPlanClickCallback,
		} = this.props;

		if (onPlanClickCallback) {
			onPlanClickCallback(type);
		}
	}



	render() {
		const {
			accountId,
			disabledPlans,
		} = this.props;

		return (
			<List size={ListSize.Small}>
				{LIST_OF_ALL_PLANS.v4.toArray().map((planType, index) => {
					const isDisabled = disabledPlans[planType] !== undefined;

					return (
						<PlanCard
							isDisabled={isDisabled}
							isEnterprise={planType === GraphQL.AccountPlan.Enterprise}
							key={'plan-card-' + index}
							name={planType === GraphQL.AccountPlan.Enterprise ? (
								<AttachedEnterpriseRibbon>
									<PlanName plan={planType} />
								</AttachedEnterpriseRibbon>
							) : (
								<PlanName plan={planType} />
							)}
							onClick={this._handlePlanClick.bind(null, planType)}
							priceOverview={(
								<PlanPriceSummary
									accountId={accountId}
									disabledReason={disabledPlans[planType]}
									planType={planType}
									view={PlanPriceSummaryView.Overview}
								/>
							)}
						/>
					);
				})}
			</List>
		);
	}

}

PlansOverviewSection.propTypes = {
	disabledPlans: PropTypes.object,
	onPlanClickCallback: PropTypes.func,
};



export default PlansOverviewSection;
